"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _checkbox = _interopRequireDefault(require("../Checkbox/checkbox"));

var _chip = _interopRequireDefault(require("../Chip/chip"));

var _unique = _interopRequireDefault(require("../helpers/unique.id"));

var _Select = _interopRequireDefault(require("./Select"));

var _Dropdown = _interopRequireDefault(require("./Dropdown"));

var _dropdownUtils = require("./dropdownUtils");

var _compareElementType = _interopRequireDefault(require("../helpers/compare-element-type"));

var _subComponents = require("./subComponents");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DEFAULT_PLACEHOLDER = 'Select options';

var idGenerator = function idGenerator(index, groupIndex) {
  return function (id) {
    return id ? "".concat(id).concat(groupIndex ? "-".concat(groupIndex) : '', "-").concat(index++) : (0, _unique.default)();
  };
};

function renderOptions(children, props, groupIndex) {
  var onSelectItem = props.onSelectItem,
      value = props.value,
      query = props.query,
      uid = props.uid;
  var valueArr = value ? value.split(',').map(function (s) {
    return s.trim();
  }) : [];

  var handleItemSelection = function handleItemSelection(child) {
    return function (event) {
      onSelectItem(child);
    };
  };

  var generateCheckboxId = idGenerator(0, groupIndex);
  var totalOptions = 0;

  var renderedChildren = _react.default.Children.map(children, function (child, index) {
    if ((0, _dropdownUtils.isNotDropdownItem)(child)) return;

    if ((0, _compareElementType.default)(child, _subComponents.DropdownOptionGroup)) {
      var groupOptions = renderOptions(child.props.children, props, index);
      totalOptions += groupOptions.totalOptions;
      return _react.default.createElement(_subComponents.DropdownOptionGroup, child.props, groupOptions.renderedChildren);
    }

    var itemInfo = (0, _dropdownUtils.getItemInfo)(child);
    if (query && !(0, _dropdownUtils.itemMatchesQuery)(itemInfo.name || itemInfo.value, query)) return;
    ++totalOptions;
    var onItemSelect = handleItemSelection(child);
    var active = valueArr.includes(itemInfo.value);
    var checkboxId = generateCheckboxId(uid);
    return _react.default.cloneElement(child, {
      children: _react.default.createElement(_checkbox.default, {
        id: checkboxId,
        checked: active,
        value: itemInfo.value,
        onChange: onItemSelect
      }, child.props.children)
    });
  });

  return {
    renderedChildren: renderedChildren,
    totalOptions: totalOptions
  };
}

function getItemsByValue(children, value) {
  var valueArr = value ? value.split(',').map(function (s) {
    return s.trim();
  }) : [];

  var matches = _react.default.Children.map(children, function (child) {
    if ((0, _dropdownUtils.isNotDropdownItem)(child)) return;

    if ((0, _compareElementType.default)(child, _subComponents.DropdownOptionGroup)) {
      return getItemsByValue(child.props.children, value);
    }

    var itemInfo = (0, _dropdownUtils.getItemInfo)(child);
    if (!itemInfo) return;
    return valueArr.includes(itemInfo.value) ? child : undefined;
  });

  return matches;
}

function defaultValueToSelection(value, selectedItems, small, large) {
  if (!selectedItems) return null;

  var _selectedItems = _toArray(selectedItems),
      first = _selectedItems[0],
      second = _selectedItems[1],
      remainder = _selectedItems.slice(2);

  var remainderValue = remainder && remainder.length ? '+' + remainder.length : '';
  var displayedValues = [first, second];

  if (first || second) {
    return _react.default.createElement("div", {
      className: "co-dropdown__chips"
    }, displayedValues.map(function (child, index) {
      if (child) {
        var chip = child.props.children;
        return _react.default.createElement(_chip.default, {
          key: index,
          small: small,
          large: large
        }, chip);
      }
    }), remainderValue ? _react.default.createElement(_chip.default, {
      alternate: true,
      info: true,
      small: small,
      large: large
    }, remainderValue) : null);
  } else {
    return null;
  }
}

var MultiDropdown = function MultiDropdown(_ref) {
  var id = _ref.id,
      children = _ref.children,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? DEFAULT_PLACEHOLDER : _ref$placeholder,
      disabled = _ref.disabled,
      open = _ref.open,
      searchable = _ref.searchable,
      searchPlaceholder = _ref.searchPlaceholder,
      _ref$closeOnBlur = _ref.closeOnBlur,
      closeOnBlur = _ref$closeOnBlur === void 0 ? true : _ref$closeOnBlur,
      small = _ref.small,
      large = _ref.large,
      smallMenu = _ref.smallMenu,
      largeMenu = _ref.largeMenu,
      _ref$valueToSelection = _ref.valueToSelection,
      valueToSelection = _ref$valueToSelection === void 0 ? defaultValueToSelection : _ref$valueToSelection,
      onChange = _ref.onChange,
      onSearch = _ref.onSearch,
      onFocus = _ref.onFocus,
      noResultsMessage = _ref.noResultsMessage,
      selectAllLabel = _ref.selectAllLabel,
      props = _objectWithoutProperties(_ref, ["id", "children", "placeholder", "disabled", "open", "searchable", "searchPlaceholder", "closeOnBlur", "small", "large", "smallMenu", "largeMenu", "valueToSelection", "onChange", "onSearch", "onFocus", "noResultsMessage", "selectAllLabel"]);

  var uid = id || (0, _unique.default)();

  var filteredChildren = _react.default.Children.toArray(children).filter(function (child) {
    return child;
  });

  return _react.default.createElement(_Select.default, {
    defaultOpen: open,
    defaultSelectedItems: (0, _dropdownUtils.getSelected)(filteredChildren),
    onChange: onChange,
    closeOnBlur: closeOnBlur,
    multiple: true
  }, function (_ref2) {
    var isOpen = _ref2.isOpen,
        toggleMenu = _ref2.toggleMenu,
        closeMenu = _ref2.closeMenu,
        query = _ref2.query,
        value = _ref2.value,
        onSelectItem = _ref2.onSelectItem,
        onToggleAllItems = _ref2.onToggleAllItems,
        onQueryChange = _ref2.onQueryChange;
    var actions = (0, _dropdownUtils.getActions)(filteredChildren);

    var _renderOptions = renderOptions(filteredChildren, {
      uid: uid,
      value: value,
      query: query,
      onSelectItem: onSelectItem,
      closeMenu: closeMenu
    }),
        renderedChildren = _renderOptions.renderedChildren,
        totalOptions = _renderOptions.totalOptions;

    var selectedItems = getItemsByValue(filteredChildren, value);
    return _react.default.createElement(_Dropdown.default, _extends({
      id: uid,
      open: isOpen,
      onFocus: !isOpen ? onFocus : undefined,
      disabled: disabled,
      large: large,
      small: small
    }, props), _react.default.createElement(_Dropdown.default.Selection, {
      onClick: toggleMenu,
      placeholder: placeholder,
      large: large
    }, valueToSelection(value, selectedItems, small, large)), isOpen && !disabled ? _react.default.createElement(Menu, {
      id: uid,
      onToggleAll: onToggleAllItems,
      value: value,
      actions: actions,
      searchable: searchable,
      searchPlaceholder: searchPlaceholder,
      toggleMenu: toggleMenu,
      query: query,
      options: filteredChildren,
      small: smallMenu,
      large: largeMenu,
      loadMore: (0, _dropdownUtils.filterLoadMore)(filteredChildren),
      onQueryChange: onSearch || onQueryChange,
      totalOptions: totalOptions,
      noResultsMessage: noResultsMessage,
      selectAllLabel: selectAllLabel
    }, renderedChildren) : null);
  });
};

var Actions = function Actions(_ref3) {
  var actions = _ref3.actions,
      toggleMenu = _ref3.toggleMenu;
  if (actions.length === 0) return null;
  var actionsList = actions.length > 0 ? (0, _dropdownUtils.processActions)(actions, toggleMenu) : null;
  return _react.default.createElement(_Dropdown.default.Actions, null, actionsList);
};

var Menu = function Menu(_ref4) {
  var id = _ref4.id,
      children = _ref4.children,
      value = _ref4.value,
      onToggleAll = _ref4.onToggleAll,
      options = _ref4.options,
      loadMore = _ref4.loadMore,
      searchable = _ref4.searchable,
      searchPlaceholder = _ref4.searchPlaceholder,
      query = _ref4.query,
      onQueryChange = _ref4.onQueryChange,
      totalOptions = _ref4.totalOptions,
      noResultsMessage = _ref4.noResultsMessage,
      selectAllLabel = _ref4.selectAllLabel,
      props = _objectWithoutProperties(_ref4, ["id", "children", "value", "onToggleAll", "options", "loadMore", "searchable", "searchPlaceholder", "query", "onQueryChange", "totalOptions", "noResultsMessage", "selectAllLabel"]);

  var optionsSelected = getItemsByValue(children, value);
  var allSelected = optionsSelected.length === totalOptions;
  var indeterminated = !allSelected && optionsSelected.length > 0;

  var onToggleAllChange = function onToggleAllChange(_ref5) {
    var target = _ref5.target;
    onToggleAll(children, target.checked);
  };

  return _react.default.createElement(_Dropdown.default.Menu, props, searchable ? _react.default.createElement(_Dropdown.default.Search, {
    searchPlaceholder: searchPlaceholder,
    query: query,
    onSearch: onQueryChange
  }) : null, _react.default.createElement(_Dropdown.default.Scrollable, null, _react.default.createElement(Actions, props), totalOptions > 0 ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(SelectAll, {
    id: "".concat(id, "-all"),
    checked: allSelected,
    indeterminated: indeterminated,
    onChange: onToggleAllChange,
    small: props.small,
    selectAllLabel: selectAllLabel
  }), _react.default.createElement(_Dropdown.default.Options, {
    divided: false
  }, (0, _dropdownUtils.processOptions)(children, true)), loadMore) : _react.default.createElement(_Dropdown.default.NoResultsMessage, {
    message: noResultsMessage
  })));
};

var SelectAll = function SelectAll(_ref6) {
  var selectAllLabel = _ref6.selectAllLabel,
      props = _objectWithoutProperties(_ref6, ["selectAllLabel"]);

  return _react.default.createElement(_Dropdown.default.Options, {
    borderBottom: true
  }, _react.default.createElement(_Dropdown.default.Option, {
    value: "all"
  }, _react.default.createElement(_checkbox.default, _extends({
    value: "all"
  }, props), selectAllLabel || (props.small ? 'All' : 'Select All'))));
};

MultiDropdown.defaultProps = {
  noResultsMessage: 'No results found'
};
MultiDropdown.propTypes = {
  id: _propTypes.string,
  children: _propTypes.any,
  selectAllLabel: _propTypes.string,
  placeholder: _propTypes.string,

  /** {bool}  Required if @@alignRight@@, @@smallMenu@@ or @@largeMenu@@ is defined */
  borderless: (0, _airbnbPropTypes.and)([(0, _airbnbPropTypes.requiredBy)('alignRight', _propTypes.bool), (0, _airbnbPropTypes.requiredBy)('smallMenu', _propTypes.bool), (0, _airbnbPropTypes.requiredBy)('largeMenu', _propTypes.bool)]),
  alignRight: _propTypes.bool,
  disabled: _propTypes.bool,
  fluid: _propTypes.bool,

  /** {bool} Mutually exclusive props: @@loading@@ @@checked@@ @@error@@ */
  loading: _dropdownUtils.statusProps,

  /** {bool} Mutually exclusive props: @@loading@@ @@checked@@ @@error@@ */
  checked: _dropdownUtils.statusProps,

  /** {bool} Mutually exclusive props: @@loading@@ @@checked@@ @@error@@ */
  error: _dropdownUtils.statusProps,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  small: _dropdownUtils.sizeProps,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  large: _dropdownUtils.sizeProps,

  /** {bool} Mutually exclusive props: @@smallMenu@@ @@largeMenu@@ */
  smallMenu: _dropdownUtils.menuSizeProps,

  /** {bool} Mutually exclusive props: @@smallMenu@@ @@largeMenu@@ */
  largeMenu: _dropdownUtils.menuSizeProps,
  open: _propTypes.bool,
  closeOnBlur: _propTypes.bool,
  tabIndex: _propTypes.string,

  /** valueToSelection allows to pass a custom value to show in the selection when a option is clicked. */
  valueToSelection: _propTypes.func,
  onChange: _propTypes.func,
  onFocus: _propTypes.func,

  /** Renders a custom message when a search returns no results. */
  noResultsMessage: _propTypes.string,
  searchable: (0, _airbnbPropTypes.requiredBy)('searchPlaceholder', _propTypes.bool),
  searchPlaceholder: _propTypes.string,
  onSearch: _propTypes.func,
  upward: _propTypes.bool
};
MultiDropdown.Action = _Dropdown.default.Action;
MultiDropdown.Actions = _Dropdown.default.Actions;
MultiDropdown.Option = _Dropdown.default.Option;
MultiDropdown.Option.Content = _Dropdown.default.Option.Content;
MultiDropdown.Option.Description = _Dropdown.default.Option.Description;
MultiDropdown.OptionGroup = _Dropdown.default.OptionGroup;
MultiDropdown.OptionGroup.Title = _Dropdown.default.OptionGroup.Title;
MultiDropdown.LoadMore = _Dropdown.default.LoadMore;
var _default = MultiDropdown;
exports.default = _default;
MultiDropdown.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MultiDropdown",
  "props": {
    "placeholder": {
      "defaultValue": {
        "value": "'Select options'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "closeOnBlur": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "valueToSelection": {
      "defaultValue": {
        "value": "function defaultValueToSelection (value, selectedItems, small, large) {\n  if (!selectedItems) return null\n\n  const [first, second, ...remainder] = selectedItems\n  const remainderValue = remainder && remainder.length ? ('+' + remainder.length) : ''\n  const displayedValues = [first, second]\n\n  if (first || second) {\n    return (\n      <div className='co-dropdown__chips'>\n        {\n          displayedValues.map((child, index) => {\n            if (child) {\n              const chip = child.props.children\n              return (\n                <Chip key={index} small={small} large={large}>{chip}</Chip>\n              )\n            }\n          })\n        }\n        {remainderValue ? <Chip alternate info small={small} large={large}>{remainderValue}</Chip> : null}\n      </div>\n    )\n  } else {\n    return null\n  }\n}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "valueToSelection allows to pass a custom value to show in the selection when a option is clicked."
    },
    "noResultsMessage": {
      "defaultValue": {
        "value": "'No results found'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Renders a custom message when a search returns no results."
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "selectAllLabel": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "borderless": {
      "type": {
        "name": "custom",
        "raw": "and([\n  requiredBy('alignRight', bool),\n  requiredBy('smallMenu', bool),\n  requiredBy('largeMenu', bool)\n])"
      },
      "required": false,
      "description": "{bool}  Required if @@alignRight@@, @@smallMenu@@ or @@largeMenu@@ is defined"
    },
    "alignRight": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "fluid": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "loading": {
      "type": {
        "name": "custom",
        "raw": "statusProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@loading@@ @@checked@@ @@error@@"
    },
    "checked": {
      "type": {
        "name": "custom",
        "raw": "statusProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@loading@@ @@checked@@ @@error@@"
    },
    "error": {
      "type": {
        "name": "custom",
        "raw": "statusProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@loading@@ @@checked@@ @@error@@"
    },
    "small": {
      "type": {
        "name": "custom",
        "raw": "sizeProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    },
    "large": {
      "type": {
        "name": "custom",
        "raw": "sizeProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    },
    "smallMenu": {
      "type": {
        "name": "custom",
        "raw": "menuSizeProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@smallMenu@@ @@largeMenu@@"
    },
    "largeMenu": {
      "type": {
        "name": "custom",
        "raw": "menuSizeProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@smallMenu@@ @@largeMenu@@"
    },
    "open": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "tabIndex": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onFocus": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "searchable": {
      "type": {
        "name": "custom",
        "raw": "requiredBy('searchPlaceholder', bool)"
      },
      "required": false,
      "description": ""
    },
    "searchPlaceholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onSearch": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "upward": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};